<div [hidden]="HttpActivity === 0">
    <mat-progress-bar [value]="HttpActivity" [mode]="'determinate'" color="accent"></mat-progress-bar>
</div>
<mat-toolbar color="primary">
    <mat-toolbar-row>

        <button mat-icon-button (click)="leftSidebarOpened = !leftSidebarOpened">
            <mat-icon>menu</mat-icon>
        </button>

        <!-- if more divisions available -->
        <ng-container *ngIf="_Global.Account.Divisions.length > 1; else onlyOneDivision">
            <button mat-button [matMenuTriggerFor]="divisions">{{_Global.Division?.CompanyName}}</button>
            <mat-menu #divisions="matMenu">
                <button mat-menu-item *ngFor="let division of _Global.Account?.Divisions"
                        (click)="_Global.Division = division">
                    {{division.CompanyName}}
                </button>
            </mat-menu>
        </ng-container>
        <ng-template #onlyOneDivision>
            <span class="division-name">{{_Global.Division?.CompanyName}}</span>
        </ng-template>


        <span class="fill-remaining-space"></span>

        <button mat-icon-button [matMenuTriggerFor]="themes">
            <mat-icon>format_color_fill</mat-icon>
        </button>

        <mat-menu #themes="matMenu">
            <mat-grid-list [cols]="2">
                <mat-grid-tile *ngFor="let theme of _App.themes">
                    <button mat-mini-fab [style.background-color]="theme.color" (click)="_App.onSetTheme(theme)">
                        <mat-icon *ngIf="_App.activeTheme === theme">check</mat-icon>
                    </button>
                </mat-grid-tile>
            </mat-grid-list>
        </mat-menu>

        <button mat-icon-button="" [matMenuTriggerFor]="add" *ngIf="_Global.hasGUIPermission('Documents') || _Global.hasGUIPermission('Crm')">
            <mat-icon>add</mat-icon>
        </button>

        <mat-menu #add="matMenu">
            <button *ngIf="_Global.hasGUIPermission('Crm')" [routerLink]="['/crm/relations/wizard']" disabled mat-menu-item>
              <mat-icon>people</mat-icon>
              <span>Relation</span>
            </button>
            <button mat-menu-item (click)="aEditor.edit()" *ngIf="_Global.hasGUIPermission('Crm')">
                <mat-icon>location_on</mat-icon>
                <span>Address</span>
            </button>
            <button mat-menu-item (click)="eEditor.edit()" *ngIf="_Global.hasGUIPermission('Documents')">
                <mat-icon>email</mat-icon>
                <span>Email</span>
            </button>
            <button mat-menu-item [matMenuTriggerFor]="documentTypes" *ngIf="_Global.hasGUIPermission('Documents')">
                <mat-icon>description</mat-icon>
                <span>Document</span>
            </button>
            <mat-menu #documentTypes="matMenu">
              <button (click)="dEditor.edit({Type: type})" *ngFor="let type of filteredDocumentTypes()"
                      mat-menu-item>{{type.Title}}</button>
            </mat-menu>
          <button (click)="aPicker.open()" *ngIf="false" mat-menu-item>
            <mat-icon>description</mat-icon>
            <span>Order</span>
          </button>
        </mat-menu>

        <button mat-icon-button [matMenuTriggerFor]="menu" id="bulletMenu">
            <mat-icon>more_vert</mat-icon>
        </button>


        <button mat-icon-button (click)="rightSidebarOpened = !rightSidebarOpened">
            <mat-icon>menu</mat-icon>
        </button>


        <mat-menu #menu="matMenu">
            <button mat-menu-item appLink link="/support/overview">
                <mat-icon>contact_support</mat-icon>
                <span>Support</span>
            </button>
            <button mat-menu-item appToggleFullScreen>
                <mat-icon>fullscreen</mat-icon>
                <span>Fullscreen</span>
            </button>
            <button mat-menu-item appLink link="/settings" *ngIf="_Global.hasGUIPermission('Settings')">
                <mat-icon>settings</mat-icon>
                <span>Settings</span>
            </button>
            <button mat-menu-item [routerLink]="['/settings/profile', _Global.Account?.Id]">
                <mat-icon>people</mat-icon>
                <span>Profile</span>
            </button>
            <button mat-menu-item (click)="logout()">
                <mat-icon>power_settings_new</mat-icon>
                <span>Log out</span>
            </button>
        </mat-menu>
    </mat-toolbar-row>
    <mat-toolbar-row>
        <span>
            <ng-container *ngFor="let breadcrumb of breadcrumbs; let i = index">
                <a appLink [link]="[breadcrumb.url]" class="mat-subtitle-1">{{ breadcrumb.label }}</a>
                <ng-container *ngIf="i !== breadcrumbs.length - 1"> > </ng-container>
            </ng-container>
        </span>
    </mat-toolbar-row>
</mat-toolbar>

<mat-sidenav-container class="example-container">
    <mat-sidenav mode="side" [opened]="leftSidebarOpened">
        <app-left-side-navigation-component></app-left-side-navigation-component>
    </mat-sidenav>

    <mat-sidenav-content>

        <div class="container-fluid">
            <router-outlet></router-outlet>
        </div>
    </mat-sidenav-content>

    <mat-sidenav style="width: 300px" mode="side" [opened]="rightSidebarOpened" position="end" id="rightSide">

        <mat-tab-group class="no-padding">
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="example-tab-icon">message</mat-icon>
                    &nbsp; Recente berichten
                </ng-template>
                <ng-container *ngFor="let msg of recentMessages">
                    <div class="row">
                        <div class="col-sm-12">
                            <h4>
                                <mat-icon class="new" *ngIf="!msg.Read">fiber_new</mat-icon>
                                <b>{{msg.SupportTicket?.Subject}}</b>
                                <button mat-icon-button mat-button color="primary"
                                        appLink [link]="['/support/overview/' + msg.SupportTicket?.Id]">
                                    <mat-icon>send</mat-icon>
                                </button>
                            </h4>
                            <p [innerHTML]="'<b>Bericht:</b> ' + msg.Message"><br>
                                <small><b>Verzonden:</b> {{msg.Sent | date:'short'}}</small>
                            </p>
                        </div>
                    </div>
                    <hr>
                </ng-container>
            </mat-tab>
        </mat-tab-group>
    </mat-sidenav>
</mat-sidenav-container>

<mat-toolbar color="primary">
    <mat-toolbar-row>
        <span class="fill-remaining-space"></span>
        <button mat-button class="small" routerLink="/shared/conditions">Terms & conditions</button>
        <button mat-button class="small" routerLink="/shared/privacy">Privacy</button>
    </mat-toolbar-row>
</mat-toolbar>

<!-- Editors for shortcut add new -->
<app-visual-article-picker #aPicker [MinQTY]="true" [Step]="true" (ListChange)="makeOrder($event)"></app-visual-article-picker>
<app-email-editor #eEditor></app-email-editor>
<app-crm-relation-editor #rEditor></app-crm-relation-editor>
<app-document-editor #dEditor></app-document-editor>
<app-crm-contact-editor #cEditor></app-crm-contact-editor>
<app-crm-address-editor #aEditor></app-crm-address-editor>
<app-document-editor #docEditor></app-document-editor>
<app-alert></app-alert>
